import React, { useEffect, useState } from "react"
import Popover from "@mui/material/Popover"
import Button from "@mui/material/Button"
import { CardContent } from "@mui/material"
import FormFieldService from "../../../services/formField"
import { PageConfig, CwComponentConfig } from "../../../models/pageConfig"
import UIService from "../../../services/UIService"
import { Color } from "../../../models/colors"
import StoreService from "../../../services/store"
import ActionService from "../../../services/action"

const CwColorPicker = (
    props: PageConfig<CwComponentConfig.ColorPicker> & {
        onChange?: (value: string) => void
    }
): React.JSX.Element => {
    const { config, name } = props
    const { edit, fieldName, formLink, resolveColor } = config
    const [errorState, setError] = useState<{
        hasError: boolean
        helperText?: string
    }>({ hasError: false, helperText: "" })
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
    const [selectedColor, setSelectedColor] = useState<string>(Color.black)

    const init = () => {
        if (props.actions)
            ActionService.exec(props.actions as any[]).then(
                (result) => {
                    if (typeof result === "string") {
                        setSelectedColor(result)
                    }
                },
                (err) => {
                    console.log(err)
                }
            )
    }

    useEffect(() => {
        init()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [edit])

    /**
     * handleClick sur le popover pour l'ouvrir
     */
    /**
     * récupère l'état (présence d'erreur) du champ
     * @param field nom du champ
     * @param currentValue nouvelle value
     */
    const getFormState = (field: string, currentValue: unknown) => {
        const s = FormFieldService.getInstance().send(
            formLink,
            field,
            currentValue
        )
        if (
            s &&
            (s.error !== errorState.hasError || s.msg !== errorState.helperText)
        ) {
            setError({
                hasError: s.error,
                helperText: s.msg,
            })
        }
    }
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (edit) setAnchorEl(event.currentTarget)
    }
    /**
     * handleClose fermeture de popover
     */
    const handleClose = () => {
        setAnchorEl(null)
    }
    /**
     * handleChange gére le changements des couleurs
     * en utilisant le onChange passer par les props du composant
     */
    const handleChange = (value: string) => {
        const newValue = resolveColor ? UIService.getColorByName(value) : value
        getFormState(fieldName, newValue)

        setSelectedColor(value)
        if (props.onChange) props.onChange(newValue)
        // save l'id ged dans le store local
        if (fieldName) StoreService.getInstance().local.set(fieldName, newValue)
    }

    const open = Boolean(anchorEl)
    const id = open ? "simple-popover" : undefined

    return (
        <div>
            <Button
                className="colorPaletteButton"
                aria-describedby={id}
                variant="contained"
                color="primary"
                style={{
                    backgroundColor: UIService.getColorByName(selectedColor),
                }}
                disabled={!edit}
                onClick={handleClick}
            />
            {edit ? (
                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "center",
                    }}
                >
                    <CardContent className="m-2">
                        <div>
                            {UIService.getInstance()
                                .getColorPalette()
                                .palette.map((color) => (
                                    <Button
                                        key={color.label}
                                        className="colorPaletteButton"
                                        onClick={() =>
                                            handleChange(color.label)
                                        }
                                        style={{ backgroundColor: color.style }}
                                    />
                                ))}
                        </div>
                    </CardContent>
                </Popover>
            ) : null}
        </div>
    )
}

export default CwColorPicker
